import Text from '../../components/Text';
import MyInvestmentsDetailFunctional from './index.function';
import { fontSizes } from '../../constants/constants';
import { Chart, HoldingView } from './components';
import ViewReverse from '../../components/ViewReverse';
import Button from '../../components/Button';
import LoaderModal from '../../components/LoaderModal';
import { useLocation } from 'react-router';

const MyInvestmentsDetail = () => {
    const { state } = useLocation()
    const { data } = state
    const {
        getContentKey,
        TextWeight,
        investment_loading,
        direction,
        navigate,
        isArabic,
        client_holdings,
        transformedData
    } = MyInvestmentsDetailFunctional({ data });
    return (
        <div>

            <Text
                text={getContentKey('my_investments_heading')}
                size={fontSizes.h24}
                weight={TextWeight.bold}
                color='text-black'
            />

            <div className='border border-grey rounded-xl mt-4 pt-4 px-5 pb-4 shadow-light'>
                <ViewReverse className='items-center justify-between'>
                    <Text text={isArabic ? data?.fundName_AR : data?.fundName_EN} size={fontSizes.h16} weight={TextWeight.semiBold} isTruncate={false} color='text-black' />

                    <Button
                        text={getContentKey('view_reports')}
                        bgColor='bg-primary'
                        className=' w-36 px-0 text-center capitalize'
                        onClick={() => {
                            navigate('/funds/my-funds/my-fund-reports', { state: { data, systemFundId: client_holdings?.systemFundId } });
                        }}
                    />
                </ViewReverse>

                <div dir={direction} className='grid grid-cols-1 lg:grid-cols-2 mt-4 gap-5'>
                    <div>
                        <HoldingView item={{ ...data, ...client_holdings?.holdings }} getContent={getContentKey} />
                    </div>
                    <Chart chartData={transformedData} />
                </div>
            </div>

            <LoaderModal open={investment_loading} />
        </div>
    );
};

export default MyInvestmentsDetail;
